var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9883 15.7225L11.3647 0.617676V2.93609L23.7437 15.7225L23.7484 15.7274L13.0258 26.8029L13.0129 26.7895L2.29736 15.7225L2.28797 15.7128L7.54831 10.2793H5.26504L0 15.7177L0.00469579 15.7225L13.0082 29.154L13.0129 29.1492L26 15.7346L25.9883 15.7225Z",
    fill: "#FE6309"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3601 4.53223V6.85064L19.9543 15.7278L13.0305 22.8794L6.10089 15.7229L6.0915 15.7132L11.3518 10.2798H9.06856L3.80353 15.7181L3.80822 15.7229L11.8836 24.0641L13.0129 25.2306L14.161 24.0459L22.2059 15.735L11.3601 4.53223Z",
    fill: "#FE6309"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4153 15.7228L14.1269 11.2885L12.9859 10.1099L11.8636 11.2691L7.55298 15.7179L11.866 20.1729L12.9953 21.3394L14.141 20.1547L18.427 15.7349L18.4153 15.7228ZM13.0152 18.9967L9.84565 15.7228L9.83625 15.7131L12.9976 12.4477L16.1672 15.7216L13.0152 18.9967Z",
    fill: "#FE6309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.a0445da0ce5d1f9ffe8644935b73a3e9.svg";
export { ForwardRef as ReactComponent };